import React, {Fragment} from 'react';
import {GUTTER_SM, MARGIN_MD, MODAL_WIDTH_XL} from "../../../styles/constants";
import EnhancedModal from '../../../components/enhanced-modal';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {
  changeMsdsMsdDetail,
  hideMsdsMsdDetail,
  readMsdsAgencies,
  readMsdsMsdDetail,
  showMsdsMsdClone,
  showMsdsMsdDownload,
  showMsdsMsdExport,
  submitMsdsMsdDetail
} from "./actions";
import {Alert, Button, Col, Modal, Row} from "antd";
import ArtefactForm, {
  ARTEFACT_FORM_MODE_EDIT,
  ARTEFACT_FORM_MODE_READ
} from '../../../components/artefact-form';
import Call from "../../../hocs/call";
import {isArtefactValid} from "../../../utils/artefactValidators";
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";

const mapStateToProps = state => ({
  nodes: state.config.nodes,
  nodeId: state.app.endpointId,
  permissions: state.app.user.permissions,
  isVisible: state.scenes.metaManager.msds.isVisible,
  msdTriplet: state.scenes.metaManager.msds.msdTriplet,
  msd: state.scenes.metaManager.msds.msd,
  agencies: state.scenes.metaManager.msds.agencies,
  appLanguage: state.app.language
});

const mapDispatchToProps = dispatch => ({
  onMsdDetailHide: () => dispatch(hideMsdsMsdDetail()),
  onMsdDetailChange: fields => dispatch(changeMsdsMsdDetail(fields)),
  onMsdDetailUpdate: (msd, annotationsConfig) => dispatch(submitMsdsMsdDetail(msd, annotationsConfig)),
  fetchMsd: msdTriplet => dispatch(readMsdsMsdDetail(msdTriplet)),
  fetchAgencies: allowedAgencies => dispatch(readMsdsAgencies(allowedAgencies)),
  onCloneShow: artefactTriplet => dispatch(showMsdsMsdClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showMsdsMsdExport(sourceTriplet)),
  onDownloadShow: (msdTriplets, lang) => dispatch(showMsdsMsdDownload(msdTriplets, lang))
});

const MsdDetail = ({
                     t,
                     appLanguage,
                     nodes,
                     nodeId,
                     permissions,
                     isVisible,
                     msdTriplet,
                     msd,
                     agencies,
                     onMsdDetailHide,
                     onMsdDetailChange,
                     onMsdDetailUpdate,
                     fetchMsd,
                     fetchAgencies,
                     onCloneShow,
                     onDownloadShow,
                     onExportShow
                   }) => {

  const currentNode = nodes.find(node => node.general.id === nodeId);
  const annotationsConfig = currentNode.annotations;

  const userHasPermissionsToEdit = (
    permissions && msdTriplet &&
    permissions.agencies.filter(agency => agency === msdTriplet.agencyID).length > 0
  );

  return (
    <Call cb={fetchMsd} cbParam={msdTriplet} disabled={!msdTriplet || msd !== null}>
      <Call cb={fetchAgencies} cbParam={permissions ? permissions.agencies : undefined}
            disabled={!isVisible}>
        <EnhancedModal
          visible={isVisible}
          width={MODAL_WIDTH_XL}
          title={userHasPermissionsToEdit
            ? t('scenes.metaManager.msds.detail.title.editMode.title', {triplet: msdTriplet})
            : t('scenes.metaManager.msds.detail.title.viewMode.title', {triplet: msdTriplet})
          }
          onCancel={onMsdDetailHide}
          footer={
            <div>
              <Button onClick={onMsdDetailHide}>{t('commons.buttons.close.title')}</Button>
              {userHasPermissionsToEdit
                ? (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (isArtefactValid(msd)) {
                        onMsdDetailUpdate(msd, annotationsConfig);
                      } else {
                        Modal.warning({
                          title: t('commons.alerts.invalidForm.title'),
                          content: t('commons.alerts.invalidForm.content')
                        });
                      }
                    }}
                  >
                    {t("commons.buttons.save.title")}
                  </Button>
                )
                : null}
            </div>
          }
          withDataLanguageSelector
        >
          <DataLanguageConsumer>
            {dataLanguage => {
              const lang = dataLanguage || appLanguage;
              return (
                <Fragment>
                  {permissions && !userHasPermissionsToEdit && (
                    <Alert
                      type="warning"
                      showIcon
                      message={t('commons.artefact.alerts.hasNotAgencyPermission')}
                    />
                  )}
                  <Row type="flex" gutter={GUTTER_SM} justify={"end"}
                       style={{marginBottom: MARGIN_MD}}>
                    <Col>
                      <Button
                        type="primary"
                        shape="circle"
                        icon="download"
                        size="small"
                        title={t('commons.artefact.buttons.download.title')}
                        onClick={() => onDownloadShow([msdTriplet], lang)}
                      />
                    </Col>
                    {permissions && (
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="copy"
                          size="small"
                          title={t('commons.artefact.buttons.clone.title')}
                          onClick={() => onCloneShow(msdTriplet)}
                        />
                      </Col>
                    )}
                    <Col>
                      <Button
                        type="primary"
                        shape="circle"
                        icon="export"
                        size="small"
                        title={t('commons.artefact.buttons.export.title')}
                        onClick={() => onExportShow(msdTriplet)}
                      />
                    </Col>
                  </Row>
                  {msd && (
                    <ArtefactForm
                      artefact={msd}
                      mode={userHasPermissionsToEdit ? ARTEFACT_FORM_MODE_EDIT : ARTEFACT_FORM_MODE_READ}
                      agencies={agencies}
                      onChange={onMsdDetailChange}
                      isMsd
                    />
                  )}
                </Fragment>
              );
            }}
          </DataLanguageConsumer>
        </EnhancedModal>
      </Call>
    </Call>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
)(MsdDetail);
